import ProductInfoTabs from "./ProductInfoTabs";

export default function ProductDescription({ product, selectedVariation }) {
  return (
    <div className="pt-10">
      <div className="product-dContent border rounded-24">
        <div className="product-dContent__header border-bottom border-gray-100 flex-between flex-wrap gap-16">
          <ul
            className="nav common-tab nav-pills mb-3"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-description-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-description"
                type="button"
                role="tab"
                aria-controls="pills-description"
                aria-selected="true"
              >
                Description
              </button>
            </li>
          </ul>
        </div>
        <div className="product-dContent__box">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-description"
              role="tabpanel"
              aria-labelledby="pills-description-tab"
              tabIndex={0}
            >
              <div className="mb-40">
                <h6 className="mb-20">Product Description</h6>
                <div className="mb-20">
                  <div
                    className="wysiwyg mt-6"
                    dangerouslySetInnerHTML={{
                      __html:
                        selectedVariation?.description || product?.description,
                    }}
                  />
                </div>

                <ProductInfoTabs productDetails={product?.details} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
